import * as React from "react";
import styled from "styled-components";
import { left as leftRight } from "../../../utils/rtl";
import defaultTheme from "../../../defaultTheme";
const StyledBar = styled.div.withConfig({
  displayName: "Bar__StyledBar",
  componentId: "sc-1dsvlo8-0"
})(["display:block;position:relative;width:100%;height:24px;cursor:pointer;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none;"]);
export const calculateBarPosition = (value, max, min, hasHistogram) => {
  if (Array.isArray(value)) {
    return {
      left: +((value[0] - min) / (max - min + 1) * 100).toFixed(1),
      width: +((value[value.length - 1] - value[0] + 1) / (max - min + 1) * 100).toFixed(1)
    };
  }
  const addition = hasHistogram ? 1 : 0;
  return {
    left: 0,
    width: +((value - min + addition) / (max - min + addition) * 100).toFixed(1)
  };
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const StyledBarPart = styled(({
  width,
  left,
  theme,
  active,
  ...props
}) => /*#__PURE__*/React.createElement("div", props)).attrs(({
  width,
  left,
  theme
}) => {
  return {
    style: {
      width: `${width}%`,
      [leftRight({
        theme
      })]: `${left}%`
    }
  };
}).withConfig({
  displayName: "Bar__StyledBarPart",
  componentId: "sc-1dsvlo8-1"
})(["position:absolute;height:4px;top:10px;border-radius:4px;background-color:", ";"], ({
  theme,
  active
}) => active ? theme.orbit.paletteBlueNormal : theme.orbit.paletteCloudNormal);
StyledBarPart.defaultProps = {
  theme: defaultTheme
};
const Bar = /*#__PURE__*/React.forwardRef(({
  onMouseDown,
  value,
  max,
  min,
  hasHistogram
}, ref) => {
  const {
    left,
    width
  } = calculateBarPosition(value, max, min, hasHistogram);
  return /*#__PURE__*/React.createElement(StyledBar, {
    ref: ref,
    onMouseDown: onMouseDown
  }, /*#__PURE__*/React.createElement(StyledBarPart, {
    width: 100,
    left: 0
  }), /*#__PURE__*/React.createElement(StyledBarPart, {
    active: true,
    left: left,
    width: width
  }));
});
Bar.displayName = "Bar";
export default Bar;